import { Injectable } from '@angular/core';

@Injectable()
export class AppConstant {
  mobileResolution = '(max-width: 1024px)';
}
